import { makeStyles, Typography } from "@material-ui/core";
import AgapeSlider from "../../../common/slider/AgapeSlider";
import Image from "next/image";
const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: "30px",

    [theme.breakpoints.up("md")]: {
      width: "100%",
      height: "550px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
  },
  image: {
    borderRadius: "10px",
    height: "200px",
  },
  items: {
    [theme.breakpoints.up("md")]: {
      padding: 10,
      paddingTop: 0,
    },
  },
  DescriptionDiv: {
    backgroundColor: "#FFFFFF",
    padding: "25px",
    boxShadow: "0 4px 6px 0 rgba(50, 50, 93, 0.11)",
    marginTop: "10px",
    width: "100%",
  },
  description: {
    fontFamily: "Vazir-bold",
    fontSize: "16px",
    textAlign: "justify",
    maxWidth: "100% !important",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    wordBreak: "break-word",
    fontWeight: "bold",
    "& *": {
      maxWidth: "100% !important",
      maxHeight: "100% !important",
    },
  },
}));

const CampaignDataComponent = ({ data }) => {
  function createMarkup(myHtml) {
    return { __html: myHtml };
  }
  const classes = useStyles();

  return (
    <>
      {data &&
        data?.dedicated_payment_page_gallery &&
        data?.dedicated_payment_page_gallery.length > 0 && (
          <div className={classes.container}>
            <Typography style={{ fontWeight: "bold" }}>گالری تصاویر</Typography>

            <AgapeSlider
              listLength={data?.dedicated_payment_page_gallery.length}
              slidesToShowDesktop={1}
              slidesToShowTablet={1}
              slidesToShowMobile={1}
              arrow
              autoplay
              infinite
            >
              {data?.dedicated_payment_page_gallery?.map((item) => (
                <>
                  {item.url && (
                    <Image
                      key={item.id}
                      src={item.url}
                      layout="responsive"
                      placeholder="blur"
                      blurDataURL={item.url}
                      alt={item.url}
                      width={"100%"}
                      height={"40px"}
                    />
                  )}
                </>
              ))}
            </AgapeSlider>
          </div>
        )}
      <div className={classes.DescriptionDiv}>
        {data && data?.dedicated_payment_page_title && (
          <Typography
            style={{
              fontWeight: "bold",
              marginBottom: "10px",
              fontSize: "18px",
            }}
          >
            {data?.dedicated_payment_page_title}
          </Typography>
        )}

        {data && data?.dedicated_payment_page_summary && (
          <Typography
            style={{
              wordWrap: "break-word",
              overflowWrap: "break-word",
              wordBreak: "break-word",
              fontWeight: "bold",
            }}
          >
            {data?.dedicated_payment_page_summary}
          </Typography>
        )}
      </div>
      {data && data?.dedicated_payment_page_description && (
        <div className={classes.DescriptionDiv}>
          <div
            className={classes.description}
            dangerouslySetInnerHTML={createMarkup(
              data?.dedicated_payment_page_description
            )}
          />
        </div>
      )}
    </>
  );
};
export default CampaignDataComponent;
